<div *ngIf="(basket$ | async).basket as basket">
  <div *ngIf="(restaurant$ | async).restaurant as restaurant">
    <lib-bag [basket]="basket" [location]="restaurant" (checkout)="onCheckout()" (close)="onClose()"></lib-bag>
  </div>
</div>
